




import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  IDynamicTemplateExecutable,
  instanceOfIDynamicTemplateExecutable,
} from "../../../../domain/document/items";
import {
  ExternalTemplateExecuteResult,
} from "../../../../domain/localhost/items";
import { Dictionary } from "../../../../domain/system";
import { EditingDocument } from "..";
import { CommonDialogsAccessor } from "../CommonComponentsAccessor";

@Component
export default class DynamicTemplateAdapter extends Mixins() {
  @Prop()
  source: EditingDocument;

  @Prop()
  dialogs: CommonDialogsAccessor;

  isInputable(source: IDynamicTemplateExecutable): boolean {
    return instanceOfIDynamicTemplateExecutable(source)
        && source.dynamicTemplateFormats
        && (0 < source.dynamicTemplateFormats.length);
  }

  async input(source: IDynamicTemplateExecutable): Promise<ExternalTemplateExecuteResult> {
    if (!this.isInputable(source)) {
      throw new Error("invalid item");
    }
    const parameters = await this.toParameters(source);
    if (!parameters) {
      this.$logger.info("ダイナミックテンプレート選択処理がキャンセルされました。");
      return null;
    }
    const result = await this.dialogs.application.launcher.show(null, parameters, null);
    if (!result || !result.isComplete) {
      throw new Error("ダイナミックテンプレートが正常に完了しませんでした。");
    }
    if (!result.registeredId) {
      // 出力ファイルが存在していない場合（ダイナミックテンプレート画面でキャンセルなど）
      return null;
    }
    return result;
  }

  private async toParameters(source: IDynamicTemplateExecutable): Promise<Dictionary<string, string>> {
    return !source.dynamicTemplateRegisteredId
      ? this.toNewParameters(source)    // まだ未実行.
      : this.toEditParameters(source);  // 既に実行済.
  }

  private async toNewParameters(source: IDynamicTemplateExecutable): Promise<Dictionary<string, string>> {
    const selectedTemplateCode = await this.selectTemplate(source.dynamicTemplateFormats.map(t => t.value));
    if (!selectedTemplateCode) {
      return null;
    }
    const parameters = this.createParameters(source);
    parameters.set("templateCode", selectedTemplateCode);
    return parameters;
  }

  private async toEditParameters(source: IDynamicTemplateExecutable): Promise<Dictionary<string, string>> {
    const parameters = this.createParameters(source);
    parameters.set("templateRegisteredId", source.dynamicTemplateRegisteredId);
    return parameters;
  }

  private createParameters(source: IDynamicTemplateExecutable): Dictionary<string, string> {
    if (!this.source.source.attributes.department) {
      throw new Error("文書の診療科を選択してください。");
    }
    const dictionary = new Dictionary<string, string>();
    dictionary.set("action", "dynamicTemplate");
    dictionary.set("patientId", this.source.source.attributes.patient.id);
    dictionary.set("departmentId", this.source.source.attributes.department.id);
    dictionary.set("uid", this.$store.getters.user.id);
    return dictionary;
  }

  async selectTemplate(templateCodes: string[]): Promise<string> {
    // 設定されているテンプレートが一つのときは選択画面を表示しない
    return (templateCodes.length === 1)
      ? templateCodes[0]
      : this.dialogs.dynamicTemplate.templateSelector.show(templateCodes);
  }
}
